import {
    addDays,
    addHours,
    addMinutes,
    addMonths,
    addSeconds,
    addYears,
    formatDate,
} from '@/utils/date.utils';
import { initFloating } from '@/utils/floating.utils';
import {
    getProductExceptionItem,
    goHome,
    hasProductDetail,
    isValidNumber,
    mappingCodeCombiner,
    mappingCodeParser,
    numberRound,
    numberSeparator,
    phoneParser,
    scSubNameParser,
    setCookie,
    sleep,
    updateUrlParams,
    validateEmail,
    validatePhone,
} from '@/utils/general.utils';
import { PrintUtils } from '@/runtime/utils/print-utils.runtime';
import { scrollToHeaderAnchor } from '@/utils/scroll.utils';
import { tourTooltipService } from '@/utils/tour-tooltip.utils';
import { EncodeMode, UrlEncoder } from '@/utils/url-encoder.utils';

/**
 * 安裝 Home utilities runtime
 */
export const installUtilsRuntime = (): void => {
    window.sleep = sleep;
    window.hasProductDetail = hasProductDetail;
    window.getProductExceptionItem = getProductExceptionItem;
    window.isValidNumber = isValidNumber;
    window.updateUrlParams = updateUrlParams;
    window.mappingCodeParser = mappingCodeParser;
    window.scSubNameParser = scSubNameParser;
    window.mappingCodeCombiner = mappingCodeCombiner;
    window.numberSeparator = numberSeparator;
    window.numberRound = numberRound;
    window.validateEmail = validateEmail;
    window.validatePhone = validatePhone;
    window.phoneParser = phoneParser;
    window.setCookie = setCookie;
    window.goHome = goHome;

    window.formatDate = formatDate;
    window.addSeconds = addSeconds;
    window.addMinutes = addMinutes;
    window.addHours = addHours;
    window.addDays = addDays;
    window.addMonths = addMonths;
    window.addYears = addYears;

    window.ENCODE_MODE = EncodeMode;
    window.UrlEncoder = UrlEncoder;
    window.initFloating = initFloating;
    window.scrollToHeaderAnchor = scrollToHeaderAnchor;
    window.GHTourTooltip = tourTooltipService;
    window.PrintUtils = PrintUtils;
};
